var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnPeriod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.981,
    height: 31,
    viewBox: "0 0 30.981 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retuen_period",
    transform: "translate(-782.003 -665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8505",
    "data-name": "Path 8505",
    d: "M10.691,85.8c-.207-.4-.4-.822-.569-1.242a.421.421,0,1,0-.78.317c.18.442.381.882.6,1.308a.421.421,0,1,0,.75-.383Z",
    transform: "translate(773.889 601.383)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8506",
    "data-name": "Path 8506",
    d: "M7.529,76.411c-.135-.434-.253-.879-.35-1.321a.421.421,0,1,0-.822.18c.1.466.226.934.368,1.391a.421.421,0,1,0,.8-.25Z",
    transform: "translate(776.021 608.49)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8507",
    "data-name": "Path 8507",
    d: "M5.637,67.1A.421.421,0,0,0,6,66.623c-.059-.449-.1-.906-.122-1.362a.416.416,0,0,0-.44-.4.421.421,0,0,0-.4.441c.023.479.066.961.128,1.431a.421.421,0,0,0,.473.362Z",
    transform: "translate(776.965 615.873)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8508",
    "data-name": "Path 8508",
    d: "M28.824,108.992c-.376-.254-.746-.527-1.1-.812a.421.421,0,1,0-.528.656c.372.3.761.587,1.157.854a.422.422,0,1,0,.471-.7Z",
    transform: "translate(760.555 583.408)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8509",
    "data-name": "Path 8509",
    d: "M14.626,93.391a.421.421,0,1,0-.715.445c.253.4.524.8.81,1.188a.421.421,0,0,0,.675-.5c-.271-.366-.531-.746-.77-1.129Z",
    transform: "translate(770.625 594.754)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8510",
    "data-name": "Path 8510",
    d: "M20.55,101.336a.421.421,0,0,0-.63.558c.317.358.653.706,1,1.035a.421.421,0,1,0,.581-.609C21.171,102.007,20.852,101.676,20.55,101.336Z",
    transform: "translate(766.334 588.366)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8511",
    "data-name": "Path 8511",
    d: "M28.354,2.9A15.34,15.34,0,0,0,15.8,9.482a.386.386,0,0,0,.092.535.378.378,0,0,0,.529-.093A14.5,14.5,0,0,1,35.97,5.848,14.806,14.806,0,0,1,41.24,25.29a14.524,14.524,0,0,1-18.885,6.542c-.372-.17-.743-.358-1.1-.56a.378.378,0,0,0-.517.148.385.385,0,0,0,.146.522c.378.213.768.411,1.16.59a15.245,15.245,0,0,0,16.94-2.948A15.6,15.6,0,0,0,42.6,12.617,15.355,15.355,0,0,0,28.354,2.9Z",
    transform: "translate(769.273 662.1)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8512",
    "data-name": "Path 8512",
    d: "M12.583,25.291a1.172,1.172,0,0,1-1.155-.984l-.35-2.174A.421.421,0,0,1,11.909,22l.351,2.174a.33.33,0,0,0,.377.272l2.174-.35a.421.421,0,0,1,.134.831l-2.174.35a1.166,1.166,0,0,1-.188.014Z",
    transform: "translate(772.621 648.084)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8513",
    "data-name": "Path 8513",
    d: "M43.881,23.018l-8.894-4.75a1.157,1.157,0,0,0-1.1,0L25,23.018a1.189,1.189,0,0,0-.627,1.053V34.638A1.189,1.189,0,0,0,25,35.691l8.894,4.75a1.16,1.16,0,0,0,1.1,0l8.894-4.75a1.189,1.189,0,0,0,.627-1.053V24.071a1.189,1.189,0,0,0-.629-1.053Zm-12.91,3.044a1.186,1.186,0,0,0-.644,1.062v4.239a.033.033,0,0,1-.024.036.032.032,0,0,1-.042-.009l-.8-.846a.769.769,0,0,0-.719-.223l-.522.114a.038.038,0,0,1-.032-.008.039.039,0,0,1-.014-.03V25.644a.446.446,0,0,1,.243-.4l9.214-4.726L39.662,21.6Zm3.263-7.138a.438.438,0,0,1,.413,0l2.189,1.169-8.75,4.489a1.166,1.166,0,0,0-.246.17l-2.3-1.182ZM34.074,39.7,25.34,35.034a.447.447,0,0,1-.236-.4V24.18l2.367,1.214a1.2,1.2,0,0,0-.029.25V30.4a.785.785,0,0,0,.286.607.763.763,0,0,0,.646.156l.522-.114a.035.035,0,0,1,.036.011l.8.846a.763.763,0,0,0,.843.184.781.781,0,0,0,.483-.724V27.235L33.91,28.7a1.122,1.122,0,0,0,.164.067Zm.167-11.663-2.748-1.41,8.964-4.6,2.889,1.543-8.7,4.466a.439.439,0,0,1-.4,0Zm9.536,6.6a.448.448,0,0,1-.236.4L34.806,39.7V28.765a1.145,1.145,0,0,0,.165-.068l8.805-4.517Z",
    transform: "translate(763.055 651.143)",
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnPeriod);
export default __webpack_public_path__ + "static/media/return_period.f093726f63df8c16b5754f1b334bf571.svg";
export { ForwardRef as ReactComponent };